import { render, staticRenderFns } from "./PlayPastPuzzlesToggle.vue?vue&type=template&id=6b9766de&"
import script from "./PlayPastPuzzlesToggle.vue?vue&type=script&lang=js&"
export * from "./PlayPastPuzzlesToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports